// extracted by mini-css-extract-plugin
export var navbarSubLink = "J_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "J_tJ d_f0 d_dB";
export var subPageLink = "J_gf d_gf";
export var burger = "J_vr";
export var sublinkSize = "J_vs";
export var linkSize = "J_vt";
export var Link = "J_tb y_tb y_sw y_sR";